module.exports = __webpack_public_path__ + "static/media/Admin.a04a5da0.png";